import styled from "@emotion/styled";

export const ThumbnailContainer = styled.div`
  flex-shrink: 0;

  inline-size: 100px;
  block-size: 66px;

  img {
    display: block;

    inline-size: 100px;
    block-size: 66px;

    object-fit: cover;
  }
`;
